import Vue from 'vue'
import VueRouter from 'vue-router'

import { routes } from './routes'
import { LoginFn } from '@/lib/login'
import { getSysSet } from '@/api/index'


Vue.use(VueRouter)

const router = new VueRouter({
  model: 'hash',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
  window.document.title = '座位预约系统'
  let token = sessionStorageProxy.getItem('token')
  if (!token) {
    getSysetFun(() => {
      LoginFn(to, next)
    })
  } else {
    const urlData = queryStringFn(window.location.href)
    if (urlData.buildId) {
      let queryParam = JSON.parse(sessionStorageProxy.getItem('queryParam') || "{}")
      sessionStorageProxy.setItem('queryParam', JSON.stringify({ ...queryParam, venueId: urlData.buildId }))
    }

    to.name === 'login' ? next({ path: '/main/index' }) : next()
  }
})

//获取配置信息 
function getSysetFun (callback) {
  let systemInfo = JSON.parse(sessionStorageProxy.getItem('systemInfo'))
  if (!systemInfo) {
    getSysSet().then(res => {
      if (res.data.status) {
        let systemInfo = res.data.data;
        let vueConfig = systemInfo.vueConfig || { CASLOGIN: 0 }
        if (vueConfig.CASLOGIN === 'true') {
          vueConfig.CASLOGIN = 1;
        } else if (vueConfig.CASLOGIN === 'false') {
          vueConfig.CASLOGIN = 0;
        }
        for (var valnet in vueConfig) {
          var key = valnet;
          if (vueConfig[key] == "true" || vueConfig[key] == "false") {
            vueConfig[key] = JSON.parse(vueConfig[key])
          }
        }
        systemInfo.vueConfig = vueConfig;
        window.document.title = localStorageProxy.getItem("languageType") == 'en' ? systemInfo.vueConfig.htmlTitleEn : systemInfo.vueConfig.htmlTitleZh
        sessionStorageProxy.setItem('systemInfo', JSON.stringify(systemInfo))
        sessionStorageProxy.setItem('vueConfig', JSON.stringify(systemInfo.vueConfig))
      }
      callback()
    }).catch((e) => {
      console.log(e)
      callback()
    })
  } else {
    callback()
  }

}

function queryStringFn (str) {
  let params = str.split("?")[1];
  let param = params ? params.split("&") : [];
  let obj = { sign: '', ticketCode: '', account: '', token: '' };//兼容新旧版本
  for (let i = 0; i < param.length; i++) {
    let paramsA = param[i].split("=");
    let key = paramsA[0];
    if (key == "openId") {//兼容新旧版本
      key = "openid";
    }
    let value = paramsA[1];
    obj[key] = value;
  }
  return obj;
}


export default router



// WEBPACK FOOTER //
// ./src/router/index.js